import React, { useState, useRef } from "react";
import Modal from "../../../../../../common/modal/Modal";
import axios from "axios";
import { useTranslation } from "react-i18next";
import { showToast } from "../../../../../../../core/common-service/CommonService";
import "./VoiceSampleModal.css";

export default function VoiceSampleModal({ id, onUploaded }) {
  const { t } = useTranslation();
  const [recording, setRecording] = useState(false);
  const [audioURL, setAudioURL] = useState(null);
  const [audioBlob, setAudioBlob] = useState(null);
  const mediaRecorderRef = useRef(null);
  const audioChunksRef = useRef([]);

  const startRecording = async () => {
    try {
      const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
      mediaRecorderRef.current = new MediaRecorder(stream);
      audioChunksRef.current = [];

      mediaRecorderRef.current.ondataavailable = (e) => {
        audioChunksRef.current.push(e.data);
      };

      mediaRecorderRef.current.onstop = () => {
        const blob = new Blob(audioChunksRef.current, { type: "audio/wav" });
        setAudioBlob(blob);
        setAudioURL(URL.createObjectURL(blob));
      };

      mediaRecorderRef.current.start();
      setRecording(true);
    } catch (err) {
      showToast({
        type: "warning",
        message: t("voice_modal.microphone_denied"),
      });
    }
  };

  const stopRecording = () => {
    mediaRecorderRef.current.stop();
    setRecording(false);
  };

  const startRecordingAgain = async () => {
    setAudioURL(null);
    setAudioBlob(null);
    await startRecording();
  };

  const handleUpload = async () => {
    if (!audioBlob) return;

    const formData = new FormData();
    formData.append("voice_sample", audioBlob, "voice_sample.wav");

    try {
      const res = await axios.post("uploadVoiceSample", formData);
      if (res?.data?.success) {
        showToast({
          type: "success",
          message: t("voice_modal.upload_success"),
        });
        onUploaded();
        closeModal();
      }
    } catch (err) {
      showToast({
        type: "error",
        message: t("voice_modal.upload_fail"),
      });
    }
  };

  const closeModal = () => {
    const modal = document.getElementById(id);
    if (modal) {
      modal.style.display = "none";
    }
  };

  return (
    <Modal id={id}>
      <div className="text-center px-4">
        <h2 className="text-xl font-bold mb-4">{t("voice_modal.title")}</h2>
        <p className="mb-2">{t("voice_modal.instructions")}</p>
        <blockquote className="italic text-gray-600 mb-4">
          {t("voice_modal.sample_text")}
        </blockquote>
        {!recording && !audioURL && (
          <button className="aai-voice-button" onClick={startRecording}>
            {t("voice_modal.start_recording")}
          </button>
        )}
        {recording && (
          <button className="aai-voice-stop-button" onClick={stopRecording}>
            {t("voice_modal.stop_recording")}
          </button>
        )}
        {audioURL && <audio controls src={audioURL}></audio>}
        {audioURL && (
          <div className="mt-4 flex flex-col items-center">
            <button className="aai-upload-button" onClick={handleUpload}>
              {t("continue")}
            </button>
            <button
              className="aai-record-again-button"
              onClick={startRecordingAgain}
            >
              {t("voice_modal.start_new_recording")}
            </button>
          </div>
        )}
      </div>
    </Modal>
  );
}
